export const iconFontAwesomeUsersPeoplePersonCircleExclamation = (
	<i className="fa-solid fa-person-circle-exclamation"></i>
);
